import { FileText, MessageSquare, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateZendeskCustomFieldsFillUpAr: TemplateAr = {
  name: 'أتمتة تعبئة حقول Zendesk المخصصة بالذكاء الاصطناعي',
  description:
    'عبّئ حقول Zendesk المخصصة تلقائياً أثناء المحادثة، وأعفِ فريق الدعم من الإدخال اليدوي.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'العميل' },
    { icon: Sparkles, label: 'استخراج ذكي' },
    { icon: FileText, label: 'الحقول مُعبّأة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'عبّي حقول Zendesk المخصصة وأنت في نص المحادثة، مو بعد ما تقفل التذكرة. وبينما يتكلم موظفوك مع العميل، الـ AI يلتقط النقاط الأساسية — أرقام الطلبات، وأكواد المنتجات SKU، وتصنيف المشكلة، وفئة العميل، وأي حقل مخصص ضبطته أنت. ويعبّيها بنفسه. بلا نسخ ولصق، ولا أخطاء إدخال.',
    paragraph2:
      'الـ AI يكتب بيانات الحقول مباشرة في تذاكر Zendesk، ومعها سجل تدقيق كامل. ويشتغل جنب سير العمل والمشغّلات والأتمتة اللي عندك في Zendesk أصلاً، ويحترم قواعد حقولك المخصصة ومنطق التحقق بدون ما تعدّل شي. ويتعلّم تسميات حقولك ويتأقلم مع إعداداتك.',
  },
  benefits: [
    'ما أحد يعبّي حقل بيده',
    'كل تذكرة تطلع بحقول معبّاة نفس الطريقة',
    'وقت معالجة التذكرة ينزل وتلاحظ الفرق',
    'تقاريرك تطلع أدق',
    'كل تعبئة تنزل في سجل التدقيق، لأغراض الامتثال',
    'يشتغل مع كل حقول Zendesk المخصصة عندك',
  ],
};
